<script>
  import ChipBase from "./base/ChipBase.svelte";
</script>

<ChipBase color="#4b4b84">
  AutoMPS
</ChipBase>
